// import Headphones from '../../../../../../assets/images/product-image-headphones.png'

import DatatableComponent from "../../../../../../../components/common/DatatableComponent/DatatableComponent"
import Headphones from "../../../../../../../assets/images/product-image-headphones.png"

const All = () => {
  const data = [
    { product: { image: Headphones, name: "Blue Colored Headphones", stock: 500 }, sku: "34579c", price: 35 },
    { product: { image: Headphones, name: "Blue Colored Headphones", stock: 500 }, sku: "34579c", price: 35 },
    { product: { image: Headphones, name: "Blue Colored Headphones", stock: 500 }, sku: "34579c", price: 35 },
    { product: { image: Headphones, name: "Blue Colored Headphones", stock: 500 }, sku: "34579c", price: 35 },
  ]

  const columns = [
    {
      name: "Product",
      cell: (row) => (
        <div className="d-flex gap-2">
          <div>
            <img src={row.product.image} alt="" />
          </div>
          <div>
            <div>{row.product.name}</div>
            <div>Stock: {row.product.stock}</div>
          </div>
        </div>
      ),
      flex: 2,
    },
    { name: "SKU", selector: (row) => row.sku, flex: 1 },
    { name: "Price", cell: (row) => <div>${row.price}</div>, flex: 1 },
  ]

  return (
    <div>
      <div style={{ backgroundColor: "#FBBD34", padding: ".5rem", color: "white", display: "inline-block", marginBottom: '1rem' }}>Total Products: 10</div>

      <DatatableComponent selectableRows columns={columns} data={data} type={"gray-bordered"} />
    </div>
  )
}

export default All
